export const lifecycleEvents = {
    Impression: 'Impression',
    Disposed: 'Disposed',
} as const;

export const copilotActions = {
    Operation_ClickExplainError: 'Operation_ExplainError',
    Operation_SendPrompt: 'SendPrompt',
    Operation_ResendPrompt: 'ResendPrompt',
    Operation_CancelPrompt: 'CancelPrompt',
    Operation_DiscardResponse: 'DiscardResponse',
    Operation_ClearResponse: 'ClearResponse',
    Operation_AcceptResponse: 'AcceptResponse',
    Operation_Feedback: 'Feedback',
    ClickCopilotSuggestion:'ClickCopilotSuggestion' // align with Trident-DI-Extension
} as const;

export const loggerConstants = {
    // Logging Events
    Event_ResourceAccessIdentity: 'ResourceAccessIdentity',
    Event_MonitoringUIAction: 'Monitoring',
    Event_AuthoringUIAction: 'Authoring',
    Event_OverviewUIAction: 'Overview',
    Event_ADFHomeUIAction: 'ADFHome',
    Event_ManagementUIAction: 'Management',
    Event_TriggerCrud: 'TriggerCrud',
    Event_IrCrud: 'IRCrud',
    Event_LinkedServiceCrud: 'LinkedServiceCrud',
    Event_Tour: 'Tutorial',
    Event_CRUD: 'Crud',
    Event_CopyWizard: 'CopyWizard',
    Event_DbtJobWizard: 'DbtJobWizard',
    Event_MountWizard: 'MountWizard',
    Event_CopyJobWizard: 'CopyJobWizard',
    Event_UpgradeWizard: 'UpgradeWizard',
    Event_VNetValidation: 'VNetValidation',
    Event_CustomSetupValidation: 'CustomSetupValidation',
    Event_VNetValidationCrud: 'VNetValidationCrud',
    Event_DataFlowAuthoringUIAction: 'DataFlowAuthoring',
    Event_AccessControlUIAction: 'AccessControl',
    Event_GalleryTemplate: 'GalleryTemplate',
    Event_DataFlowDebug: 'DataFlowDebug',
    Event_Performance: 'Performance',
    Event_Dependency: 'Dependency',
    Event_IrPriceRetrieve: 'IRPriceRetrieve',
    Event_SsisObjectMetadata: 'SsisObjectMetadata',
    Event_SsisTestConnection: 'SsisTestConnection',
    Event_PublishError: 'PublishError',
    Event_UseWinauth: 'UseWinauth',
    Event_SSISSideNav: 'SSISSideNav',
    Event_SSISInlinePackage: 'SSISInlinePackage',
    Event_KeyBindingTriggered: 'KeyBindingTriggered',
    Event_ResourceCreate: 'ResourceCreate',
    Event_VNetIRDataFlowDebug: 'VNetIRDataFlowDebug',
    Event_IRInteractiveAuthoring: 'InteractiveAuthoring',
    Event_Babylon: 'Babylon',
    Event_FocusMode: 'FocusMode',
    Event_CopyActivityDetailsLink: 'CopyActivityDetailsLink',
    Event_ActionResult: 'ActionResult',
    Event_DataPlaneWorkspaceSelect: 'DataPlaneWorkspaceSelection',
    Event_ExecuteIframeCommand: 'ExecuteIframeCommand',
    Event_FabricMounting: 'FabricMounting',
    Event_FabricCertifiedUsage: 'FabricCertifiedUsage',
    Event_FabricNativeCertifiedEvent: 'FabricNativeCertifiedEvent',
    Event_Copilot: 'Copilot',

    // Concepts
    Pipeline: 'pipeline',
    Activity: 'Activity',
    Adapter: 'Adapter',
    DataFlow: 'DataFlow',
    DataFlow_Pipeline: 'DataFlowPipeline',
    DataMapper: 'DataMapperCorrelationId',
    AdfDataMapper: 'AdfDataMapperCorrelationId',

    // Monitoring
    Init_MonitoringPipeline: 'MonitoringPipelineInit',
    Init_MonitoringActivity: 'MonitoringActivityInit',
    Init_MonitoringTrigger: 'MonitoringTriggerInit',
    Operation_BillingDebug: 'BillingDebugClick',
    Operation_BillingMonitoring: 'BillingMonitoringClick',
    Operation_BillingLink: 'BillingLinkClick',
    Operation_CancelSession: 'CancelSession',
    Operation_ClickDetailsPanel: 'ClickDetailsPanel',
    Operation_OpenDialog: 'OpenDialog',
    Operation_ViewPipelineRun: 'ViewPipelineRun',
    Operation_ViewPipelineRunNewTab: 'ViewPipelineRunNewTab',
    Operation_ViewPipelineRunNewWindow: 'ViewPipelineRunNewWindow',
    Operation_CopyPipelineRunLink: 'CopyPipelineRunLink',
    Operation_ViewPipelineRunsHistory: 'ViewPipelineRunsHistory',
    Operation_ViewActivityRun: 'ViewActivityRun',
    Operation_NavigateAlerts: 'NavigateAlerts',
    Operation_Metrics: 'NavigateMetrics',
    Operation_ManageAlerts: 'ManageAlerts',
    Operation_Refresh: 'Refresh',
    Operation_Edit: 'Edit',
    Operation_Filter: 'FilterByColumnHeader',
    Operation_CompareInNotebook: 'CompareInNotebook',
    Operation_Sort: 'Sort',
    Operation_PillPanel: 'Show / Hide Pill Panel',
    Operation_panelPillFilterChange: 'Pill Panel Received Filter {0}',
    Operation_ChangeDateRange: 'ChangeDateRange',
    Operation_TimeZone: 'TimeZone',
    Operation_ChangePipelineRunView: 'ChangePipelineRunView',
    Operation_NavigateBack: 'NavigateBack',
    Operation_NavigateBackToRunGroup: 'NavigateBackToRunGroup',
    Operation_Status: 'FilterByStatus',
    Operation_Cancel: 'Cancel',
    Operation_ReSubmit: 'ReSubmit',
    Operation_Yield: 'Yield',
    Operation_Rerun: 'Rerun',
    Operation_RerunFromActivity: 'RerunFromActivity',
    Operation_RerunFromFailedActivity: 'RerunFromFailedActivity',
    Operation_TriggerRerun: 'TriggerRerun',
    Operation_TriggerCancel: 'TriggerCancel',
    Operation_ChangeTiggerRunView: 'ChangeTriggerRunView',
    Operation_ClickInput: 'ClickInput',
    Operation_ClickOutput: 'ClickOutput',
    Operation_ClickOpenNotebook: 'ClickOpenNotebook',
    Operation_ClickError: 'ClickError',
    Operation_ClickWarning: 'ClickWarning',
    ClickSharePointSPNConnectorsWarning: 'ClickSharePointSPNConnectorsWarning',
    Operation_ClickLegacyConnectorsWarning: 'ClickLegacyConnectorsWarning',
    Operation_ClickFilterLegacyConnectorsToTrue: 'ClickFilterLegacyConnectorsToTrue',
    Operation_ClickFilterLegacyConnectorsToFalse: 'ClickFilterLegacyConnectorsToFalse',
    Operation_ClickCopyToClipBoard: 'ClickCopyToClipBoard',
    Operation_CopyJobUrlToClipBoard: 'CopyJobUrlToClipBoard',
    Operation_ClickErrorLog: 'ClickErrorLog',
    Operation_ClickActivitySpecificLogs: 'ClickActivitySpecificLogs',
    Operation_ClickAllLogs: 'ClickAllLogs',
    Operation_ClickDetail: 'ClickDetail',
    Operation_ClickSHIRExpressInstall: 'ClickSHIRExpressInstall',
    Operation_ChangeConsoleLogTab: 'ChangeJobDetailConsoleLogTab',
    Operation_MonitoringIR: 'MonitorIntegrationRuntime',
    Operation_MonitoringSSISIR: 'MonitorSSISIntegrationRuntime',
    Operation_Initial: 'Initial',
    Operation_MonitoringIRList: 'MonitorIntegrationRuntimeList',
    Operation_ClickUserProperties: 'ClickUserProperties',
    Operation_ClickMoreResult: 'ClickMoreResult',
    Operation_ClickCancel: 'ClickCancelPipelineRun',
    Operation_ClickRerun: 'ClickRerunPipelineRun',
    Operation_ClickOpenFilterDialog: 'ClickOpenFilterDialog',
    Operation_ClickCloseFilterDialog: 'ClickCloseFilterDialog',
    Operation_RerunMultiplePipeline: 'RerunMultiplePipelines',
    Operation_CancelMultiplePipeline: 'CancelMultiplePipelines',
    Operation_EditClickEmitter: 'EditClickEmitter',
    Operation_EditQuery: 'EditQuery',
    Operation_EditColumnsEmitter: 'EditColumnsEmitter',
    Operation_ManageAlertClickEmitter: 'ManageAlertClickEmitter',
    Operation_MetricsClickEmitter: 'MetricsClickEmitter',
    Operation_ManageMetricsClickEmitter: 'ManageMetricsClickEmitter',
    Operation_NewAlertClickEmitter: 'NewAlertClickEmitter',
    Operation_RunClickEmitter: 'MonitorRunClickEmitter',
    Operation_PauseClickEmitter: 'MonitorPauseClickEmitter',
    Operation_RerunFromActivityClickEmitter: 'MonitorRerunFromActivityClickEmitter',
    Operation_RerunFromFailedActivityClickEmitter: 'MonitorRerunFromFailedActivityClickEmitter',
    Operation_RunCancelClickEmitter: 'MonitorRunCancelClickEmitter',
    Operation_ViewActivityClickEmitter: 'MonitorViewActivityClickEmitter',
    Operation_ViewFullLogClickEmitter: 'MonitorViewFullDriverLogClickEmitter',
    Operation_ViewIRClickEmitter: 'MonitorViewIRClickEmitter',
    Operation_DownloadLogclickEmitter: 'MonitorDownloadLogClickEmitter',
    Operation_AddAzureKeyVault: 'AddAzureKeyVault',
    Operation_EditAzureKeyVault: 'EditAzureKeyVault',
    Operation_removeAzureKeyVault: 'RemoveAzureKeyVault',
    Operation_DashboardDisplayLineChart: 'DisplayLineChart',
    Operation_DashboardDisplayPieChart: 'DisplayPieChart',
    Operation_DashboardRefreshChart: 'RefreshCharts',
    Operation_AddCustomSetup: 'AddCustomSetup',
    Operation_EditCustomSetup: 'EditCustomSetup',
    Operation_RemoveCustomSetup: 'RemoveCustomSetup',
    Operation_AddPackageStore: 'AddPackageStore',
    Operation_EditPackageStore: 'EditPackageStore',
    Operation_RemovePackageStore: 'RemovePackageStore',
    Operation_OpenSSISStorageBrowser: 'OpenSSISStorageBrowser',
    Operation_CloseSSISStorageBrowserByFinish: 'CloseSSISStorageBrowserByFinish',
    Operation_CloseSSISStorageBrowserByCancel: 'CloseSSISStorageBrowserByCancel',
    Operation_ToggleView: 'Toggle grid/Chart View. isChartView={0}',
    Operation_FilterJobType: 'Filter by Job Type {0}',
    Operation_Pagination: 'Pagnation. Skipping : {0} Records',
    Operation_ViewScopeJobDetail: 'ViewScopeJobDetailPage',
    Operation_ViewScopePoolDetail: 'ViewScopePoolDetailPage',
    Operation_ViewScopePoolList: 'ViewScopePoolListPage',
    Operation_ViewSparkJobDetail: 'ViewSparkJobDetailPage',
    Operation_ViewSparkPoolDetail: 'ViewSparkPoolDetailPage',
    Operation_ViewKustoPoolDetail: 'ViewKustoPoolDetailPage',
    Operation_ViewSQLRequestDetail: 'ViewSQLRequestDetail',
    Operation_ViewKQLRequestDetail: 'ViewKQLRequestDetail',
    Operation_ViewSqlPoolDetail: 'ViewSQLPoolDetail',
    Operation_DateFilter: 'ChangeDateFilter',
    Opertion_RemovablePillFilterChange: 'ChangeRemovablePillFilter',
    Opertion_AddRemovablePill: 'Opertion_AddRemovablePill',
    Opertion_HidePillPanel: 'HidePillPanel',
    Operation_RemoveAllFilter: 'RemoveAllFilters',
    Operation_ClickOutside: 'Clicked Outside',
    Operation_CloseIconKeyUp: 'CloseIconKeyUp',
    Operation_PillClicked: 'RemovablePillClicked',
    Operation_PillKeySelected: 'OperationPillKey{0}SelectedOfType{1}',
    Operation_ExportQueryPlan: 'ExportQueryPlan',
    Operation_ExportQuery: 'ExportQuery',
    Operation_ViewRequestsEmitter: 'ViewRequestsEmitter',
    Operation_ViewSparkApplicationsEmitter: 'ViewSparkApplicationsEmitter',
    Operation_ManagePoolsEmitter: 'ManagePoolsEmitter',
    Operation_ViewAllRunningSqlRequestsEmitter: 'ViewAllRunningSqlRequestsEmitter',
    // Trigger Tab
    Operation_ActivateTrigger: 'ActivateTrigger',
    Operation_CancelTrigger: 'CancelTrigger',
    Operation_YieldTrigger: 'YieldTrigger',
    Operation_CopyJobUrlTrigger: 'CopyJobUrlTrigger',
    Operation_DeactivateTrigger: 'DeactivateTrigger',
    Operation_NewTrigger: 'NewTrigger',
    Operation_EditTrigger: 'EditTrigger',
    Operation_DeleteTrigger: 'DeleteTrigger',
    Operation_OpenTriggerPipelines: 'OpenTriggerPipelines',
    Operation_ViewRerunRanges: 'ViewRerunRanges',
    Operation_AddRerunRange: 'AddRerunRange',

    // Trigger Configuration
    Operation_FinishConfig: 'FinishConfiguration',
    Operation_SaveTriggerParameters: 'SaveTriggerParameters',
    Operation_NextConfig: 'GoToNextConfiguration',
    Operation_PreviousConfig: 'BackToPreviousConfiguration',

    // Trigger Sidenav
    Operation_RemovePipelineFromTrigger: 'RemovePipelineFromTrigger',
    Operation_EditTriggerParameters: 'EditTriggerParameters',
    Operation_SelectTrigger: 'SelectTrigger',
    Operation_SelectNewTrigger: 'SelectNewTrigger',

    // Sidenav
    Operation_CloseSidenav: 'CloseSidenav',
    Operation_Back: 'BackToPrevious',

    // PowerBI
    Operation_PowerBI_Create: 'CreatePowerBI',
    Operation_PowerBI_Edit: 'EditPowerBI',

    // Canvas
    Operation_PipelineSandboxRun: 'PipelineSandboxRun',
    Operation_PipelineProductionRun: 'PipelineProductionRun',
    Operation_ZoomIn: 'ZoomIn',
    Operation_ZoomOut: 'ZoomOut',
    Operation_SelectAll: 'SelectAll',
    Operation_Undo: 'Undo',
    Operation_Delete: 'Delete',
    Operation_Cut: 'Cut',
    Operation_Copy: 'Copy',
    Operation_CopyError: 'CopyError',
    Operation_CopyErrorDetails: 'CopyErrorDetails',
    Operation_CopyWarning: 'CopyWarning',
    Operation_CopyWarningDetails: 'CopyWarningDetails',
    Operation_Paste: 'Paste',
    Operation_Rename: 'Rename',
    Operation_ToggleCanvasLock: 'ToggleCanvasLock',
    Operation_ResetZoom: 'ResetZoom',
    Operation_ZoomToFit: 'ZoomToFit',
    Operation_ToggleMultiSelect: 'ToggleMultiSelect',
    Operation_ToggleReferenceNodes: 'ToggleReferenceNodes',
    Operation_GetDirectReferencedBy: 'GetDirectReferencedBy',
    Operation_AutoAlign: 'AutoAlign',
    Operation_ShowLineage: 'ShowLineage',
    Operation_ShowJson: 'ShowJson',
    Operation_Save: 'Save',
    Operation_Validate: 'Validate',
    Operation_ValidateCopyRuntime: 'ValidateCopyRuntime',
    Operation_AddConditionalPort: 'AddConditionalPort',
    Operation_RemoveConditionalPort: 'RemoveConditionalPort',
    Operation_TriggerSideNav: 'TriggerSideNav',
    Operation_OpenProperties: 'OpenProperties',
    Operation_PipelineZoomToggle: 'PipelineZoomToggle',

    // Trigger Crud
    TriggerCrud_TriggerName: 'Trigger Now for "{0}"',
    Activated: 'Activated',
    Deactivated: 'Deactivated',
    Create: 'Create',
    Update: 'Update',
    Delete: 'Delete',
    TriggerNow: 'TriggerNow',

    // Authoring Sidebar
    Operation_SwitchMode: 'SwitchMode',
    GitMode: 'Git',
    GitHub: 'GitHub',
    GitHubEnterprise: 'GitHubEnterprise',
    Vsts: 'Vsts',
    AzDevOpsSever: 'AzureDevOpsServer',
    LiveMode: 'Live',
    Operation_ConnectionToDataStore: 'ConnectionToDataStore',
    Operation_NewDataset: 'NewDataset',
    Operation_NewLinkConnection: 'NewLinkConnection',
    Operation_NewDatamapper: 'NewDatamapper',
    Operation_NewPipeline: 'NewPipeline',
    Operation_NewFlowlet: 'NewFlowlet',
    Operation_NewDataFlow: 'NewDataFlow',
    Operation_NewPowerQueryDataFlow: 'NewPowerQueryDataFlow',
    Operation_SelectConnections: 'SelectConnections',
    Operation_SelectTriggers: 'SelectTriggers',
    Operation_SelectGallery: 'SelectGallery',
    Operation_SelectBabylon: 'SelectBabylon',
    Operation_DragPipeline: 'DragPipeline',
    Operation_DragDataset: 'DragDataset',
    Operation_DragDataFlow: 'DragDataFlow',
    Operation_DragDataMapper: 'DragDataMapper',
    Operation_DragDataAdfCdc: 'DragDataAdfCdc',
    Operation_DragWranglingDataFlow: 'DragWranglingDataflow',
    Operation_DragPowerQuery: 'DragPowerQuery',
    Operation_DragTemplate: 'DragTemplate',
    Operation_DragSynapseNotebook: 'DragSynapseNotebook',
    Operation_DragSynapseScopeJobDefinition: 'DragSynapseScopeJobDefinition',
    Operation_DragSynapseSparkJobDefinition: 'DragSynapseSparkJobDefinition',
    Operation_DragSynapseSqlScript: 'DragSynapseSqlScript',
    Operation_DeleteResource: 'DeleteResource',
    Operation_Sync: 'Sync',
    Operation_PublishInLiveMode: 'PublishInLiveMode',
    Operation_PublishInGitMode: 'PublishInGitMode',
    Operation_ExportArmTemplate: 'ExportArmTemplate',
    Operation_ArmTemplateClicked: 'ArmTemplateClicked',
    Operation_ArmTemplateDownloaded: 'ArmTemplateDownloaded',
    Operation_OpenResourceMenu: 'OpenResourceMenu',
    Operation_DebugResource: 'DebugResource',
    Operation_TriggerResource: 'TriggerResource',
    Operation_MonitorResource: 'MonitorResource',
    Operation_EditResource: 'EditResource',
    Operation_DownloadSupportFiles: 'DownloadSupportFiles',
    Operation_ImportFromSupportFiles: 'ImportFromSupportFiles',
    Operation_OpenResourceWorkingBranch: 'OpenResourceWorkingBranch',
    Operation_OpenResourceDeployedBranch: 'OpenResourceDeployedBranch',
    Operation_OpenCopyWizard: 'OpenCopyWizard',
    Operation_Publish: 'Publish',
    Operation_Publish_ArmWithGlobalParameters: 'PublishArmWithGlobalParameters',
    Operation_Publish_ArmWithGlobalParameters_New: 'PublishArmWithGlobalParametersNew',
    Operation_Publish_ArmwithOutGlobalParameters: 'PublishArmWithOutGlobalParameters',
    Operation_ExportArm_WithGlobalParameters: 'ExportArmWithGlobalParameters',
    Operation_ExportArm_WithOutGlobalParameters: 'ExportArmWithOutGlobalParameters',
    Operation_Config_ArmWithGlobalParameters_New: 'ConfigArmWithGlobalParametersNew',
    Operation_PublishDiffPrompt: 'PublishDiffPrompt',
    Operation_PostPublish: 'PostPublish',
    Operation_ConfigureGit: 'ConfigureGit',
    Operation_ConfigureGitHub: 'ConfigureGitHub',
    Operation_ConfigureADO: 'ConfigureADO',
    Operation_ConfigureADOWithCrossTenant: 'ConfigureADOWithCrossTenant',
    Operation_ConfigureADOServer: 'ConfigureADOServerWithPAT',
    Operation_SignInCrossTenant: 'ADOCrossTenantSignIn',
    Operation_GitCrossTenantConfiguration: 'GitCrossTenantConfiguration',
    Operation_CrossTenantSignInDialogOpened: 'ADOCrossTenantSignInDialogOpened',
    Operation_RemoveGit: 'RemoveGit',
    Operation_ConfigureSelectiveDeployment: 'ConfigureSelectiveDeployment',
    Operation_GitConfigureEnableComment: 'GitConfigureEnableComment',
    Operation_GitConfigureDisableComment: 'GitConfigureDisableComment',
    Operation_GitConfigEditEnableComment: 'GitConfigEditEnableComment',
    Operation_GitConfigEditDisableComment: 'GitConfigEditDisableComment',
    Operation_GitEnableAutoSave: 'GitEnableAutoSave',
    Operation_GitDisableAutoSave: 'GitDisableAutoSave',

    Operation_BrowseFromCurrentPath: 'BrowseFromCurrentPath',
    Operation_BrowseButtonClick: 'BrowseFromRootPath',
    Operation_ParseNonObjectAsObject: 'ParseNonObjectAsObject',

    // Linked service Tab
    Operation_NewLinkedService: 'NewLinkedService',
    Operation_EditLinkedService: 'EditLinkedService',
    Operation_DeleteLinkedService: 'DeleteLinkedService',
    Operation_MoreLinkedService: 'MoreLinkedService',

    // Linked service Configuration
    Operation_SelectLinkedServiceType: 'SelectLinkedServiceType',
    Operation_TestConnectionToFilePath: 'TestConnectionToFilePath',
    Operation_SelectLinkedService: 'SelectLinkedService',
    Operation_LSConnectionStringParseButtonClick: 'LSConnectionStringParseButtonClick',
    Operation_LSConnectionStringParsed: 'LSConnectionStringParsed',
    Operation_LSConnectionStringParseCancelled: 'LSConnectionStringParseCancelled',

    // Query API
    Operation_TestConnection: 'TestConnection',
    Operation_QueryAPINavigation: 'QueryAPINavigation',
    Operation_ImportSchema: 'ImportSchema',
    Operation_PreviewData: 'PreviewData',
    Operation_DetectFileFormat: 'DetectFileFormat',
    Operation_DetectColumnMapping: 'DetectColumnMapping',
    Operation_ExecuteTabularData: 'ExecuteTabularData',
    Operation_ListStoredProcedure: 'ListStoredProcedure',
    Operation_ListStoredProcedureParameter: 'ListStoredProcedureParameter',
    Operation_ListFunction: 'ListFunction',
    Operation_ListFunctionParameter: 'ListFunctionParameter',
    Operation_DynamicsAlternateKey: 'DynamicsAlternateKey',
    Operation_PreviewScript: 'PreviewScript',
    Operation_GetItemMetadata: 'GetItemMetadata',
    Operation_ResolveExpressions: 'ResolveExpressions',
    Operation_ReadStream: 'ReadStream',
    Operation_WriteStream: 'WriteStream',

    // IR Tab
    Operation_NewIntegrationRuntime: 'NewIntegrationRuntime',
    Operation_EditIntegrationRuntime: 'EditIntegrationRuntime',
    Operation_DebugIntegrationRuntime: 'DebugIntegrationRuntime',
    Operation_DeleteIntegrationRuntime: 'DeleteIntegrationRuntime',
    Operation_Start: 'Start',
    Operation_Stop: 'Stop',
    Operation_RetryIntegrationRuntime: 'RetryIntegrationRuntime',

    // Dataset Panel
    Operation_CancelImportSchema: 'CancelImportSchema',
    Operation_EditDataset: 'EditDataset',
    Operation_EditDataFlow: 'EditDataFlow',
    Operation_EditFlowlet: 'EditFlowlet',
    Operation_AddSchemaColumn: 'AddSchemaColumn',
    Operation_ClearSchemaColumns: 'ClearSchemaColumns',
    Operation_DeleteSchemaColumns: 'DeleteSchemaColumns',

    // Activity Panel
    Operation_ChangeActivityTab: 'ChangeActivityTab',
    Operation_DocumentationClick: 'DocumentationClick',

    // Activity - Retry Conditions
    Operation_AddRetryCondition: 'AddRetryCondition',
    Operation_DeleteRetryCondition: 'DeleteRetryCondition',
    Operation_DuplicateRetryCondition: 'DuplicateRetryCondition',
    Operation_SelectExponentialRetryInterval: 'SelectExponentialRetryInterval',

    // Activity
    Operation_AddScript: 'AddScript',
    Operation_BrowseStorage: 'BrowseStorage',
    Operation_BrowseLocal: 'BrowseLocal',
    Operation_AutoFill: 'AutoFill',
    Operation_UploadFile: 'UploadFile',
    Operation_SetFileStoragePath: 'SetFileStoragePath',
    Operation_OpenScriptFlow: 'OpenScriptFlow',
    Operation_AzureFunctionButton: 'AzureFunctionButton',
    Operation_OpenAzureMLServicePortal: 'OpenAzureMLServicePortal',
    Operation_SparkHistoryServer: 'SparkHistoryServer',
    Operation_SparkHistoryServer_ViewExecutorUtilization: 'ViewExecutorUtilization',
    Operation_SparkHistoryServer_viewJobErrorDetail: 'viewJobErrorDetail',
    Operation_SparkHistoryServer_viewStageErrorDetail: 'viewStageErrorDetail',
    Operation_ClickContactSupport: 'clickContactSupport',
    Operation_DownloadLogUsingCMD: 'DownloadLogUsingCMD',
    Operation_OpenSparkUI: 'OpenSparkUI',
    Operation_Properties: 'Properties',
    Operation_ClearAllUnmappedCols: 'ClearAllUnmappedCols',
    Operation_AddColumnMapping: 'AddColumnMapping',
    Operation_ClearColumnMapping: 'ClearColumnMapping',
    Operation_ResetColumnMapping: 'ResetColumnMapping',
    Operation_DeleteColumnMapping: 'DeleteColumnMapping',
    Operation_EnableTimestampNtz: 'EnableTimestampNtz',

    // Overview
    Operation_Button: 'Button',
    Operation_Link: 'Link',
    Operation_CreatePipeline: 'CreatePipeline',
    Operation_CreateDataFlow: 'CreateDataFlow',
    Operation_ConfigureSSISIR: 'ConfigureSSISIR',
    Operation_ConfigureRepository: 'ConfigureRepository',
    Operation_ReleaseNotes: 'ReleaseNotes',
    Operation_Notifications: 'Notifications',
    Operation_NotificationDetails: 'NotificationDetails',
    Operation_Gallery: 'Gallery',
    Operation_Gallery_SAP: 'GallerySAP',
    Operation_PartnerCenter: 'PartnerCenter',
    DataFlowVideoLink: 'DataFlowVideoLink',
    OverviewSurveyLink: 'SurveyLink',
    DataFlowSignUpLink: 'DataFlowSignUpLink',
    OperationCountLink: 'BillingOperationCount',
    Operation_ExpressCreateSsisIr: 'ExpressCreateSSISIR',
    Operation_OpenPortalSettingsPanel: 'OpenPortalSettingsPanel',
    Operation_ChangeRegionalFormatLocale: 'Regional format locale code changed from {0} to {1}',

    Operation_OpenRelatedTab: 'OpenRelatedTab',
    Operation_OpenEntityInRelatedTab: 'OpenEntityInRelatedTab',

    Operation_TroubleshootingLinkClick: 'TroubleshootingLinkClick',

    // Authoring Main
    Operation_GitHubAuthorization: 'GitHubAuthorization',
    Operation_CancelDeployment: 'CancelDeployment',
    Operation_RefreshResources: 'RefreshResources',
    Operation_ValidateAll: 'ValidateAll',
    Operation_DiscardAll: 'DiscardAll',
    Operation_SaveAll: 'SaveAll',
    Operation_BranchSwitch: 'BranchSwitch',
    Operation_ResourceDownload: 'ResourceDownload',
    Operation_FirstSetResourceDownload: 'FirstSetResourceDownload',
    Operation_ResourceReload: 'ResourceReload',
    Operation_UpgradeFactory: 'UpgradeFactory',
    Operation_CloseUpgradeFactory: 'CloseUpgradeFactory',
    Operation_UpgradeViaNewApi: 'UpgradeViaNewApi',
    Operation_OpenUpgradeFactory: 'OpenUpgradeFactory',
    Operation_ADOServerAuthorization: 'AzureDevOpsServerAuthorization',

    // DataFlow
    Operation_EnableAutoMap: 'EnableAutoMap',
    Operation_DisableAutoMap: 'DisableAutoMap',
    Operation_InsertRuleBasedMapping: 'InsertRuleBasedMapping',
    Operation_InsertFixedMapping: 'InsertFixedMapping',
    Operation_ColumnsStatistic: 'ColumnsStatistic',
    Operation_FunctionsStatistic: 'FunctionsStatistic',
    Operation_DataFlowSandboxRun: 'DataFlowSandboxRun',
    Operation_DataFlowExpColumnSave: 'DataFlowExpColSave',
    Operation_DataFlowExpColumnDiscard: 'DataFlowExpColDiscard',
    Operation_DataFlowExpressionValidation: 'DataFlowExpressionValidation',
    Operation_DataFlowExpressionValidationAPI: 'DataFlowExpressionValidationAPI',
    Operation_AddColumnPattern: 'AddColumnPattern',

    Operation_StartDataFlowDebug: 'StartDebugSession',
    Operation_RunDataFlowDebug: 'ExecuteDebugRun',
    Operation_ExecuteDataFlowDataPreview: 'ExecuteDataFlowDataPreview',
    Operation_DataFlowDebugFromStorage: 'UseFileFromStorage',
    Operation_TurnOnDebugSucceeded: 'TurnOnDebugSucceeded',
    Operation_TurnOnDebugFailed: 'TurnOnDebugFailed',
    Operation_TurnOnDebugTimeout: 'TurnOnDebugTimeout',
    Operation_DataPreviewColumnSelected: 'DataPreviewColumnSelected',
    Operation_DataPreviewConfirm: 'DataPreviewConfirm',
    Operation_DataPreviewDiscard: 'DataPreviewDiscard',
    Operation_DataPreviewModify: 'DataPreviewModify',
    Operation_DataPreviewStatistics: 'DataPreviewStatistics',
    Operation_DataPreviewRemove: 'DataPreviewRemove',
    Operation_DataPreviewMapDrifted: 'DataPreviewMapDrifted',
    Operation_ParseTransformDetectType: 'ParseTransformDetectType',
    Operation_HelpGraphic: 'HelpGraphic',
    Operation_ExpressionDocumentation: 'ExpressionDocumentation',

    Operation_PartitionMethodChange: 'PartitionMethodChange',
    Operation_JoinTypeChange: 'JoinTypeChange',
    Operation_JoinMatchTypeChange: 'JoinMatchTypeChange',
    Operation_TransformationPanelTabChange: 'TransformationPanelTabChange',

    Operation_DataFlowSourceDatasetChange: 'DataFlowSourceDatasetChange',
    Operation_DataFlowSinkDatasetChange: 'DataFlowSinkDatasetChange',
    Operation_DataFlowSinkErrorHandlingChange: 'DataFlowSinkErrorHandlingChange',

    Operation_DataFlowSourceFormatChange: 'DataFlowSourceFormatChange',
    Operation_DataFlowSinkFormatChange: 'DataFlowSinkFormatChange',
    Operation_DataFlowSourceConnectionOptionChange: 'DataFlowSourceConnectionOptionChange',
    Operation_DataFlowSinkConnectionOptionChange: 'DataFlowSinkConnectionOptionChange',

    Operation_DataFlowParseDSLAsync: 'DataFlowParseDSLAsync',
    Operation_DataFlowParseDSL: 'DataFlowParseDSL',

    // Wrangling DataFlow
    Operation_WranglingDataflowCanvasOpened: 'WranglingDataflowCanvasOpened',
    Operation_WranglingDataflowCanvasOpenFailed: 'WranglingDataflowCanvasOpenFailed',
    Operation_WranglingDataflowValidationFailed: 'WranglingDataflowValidationFailed',
    Operation_WranglingDataflowValidationPassed: 'WranglingDataflowValidationPassed',
    Operation_WranglingDataflowCanvasSettingsClicked: 'WranglingDataflowCanvasSettingsClicked',
    Operation_NewWranglingDataflowConfiguration: 'NewWranglingDataflowConfiguration',
    Operation_WranglingDataflowConfigSourceDatasetsChanged: 'WranglingDataflowConfigurationSourceDatasetsChanged',
    Operation_WranglingDataflowConfigSinkDatasetsChanged: 'WranglingDataflowConfigurationSinkDatasetsChanged',
    Operation_WranglingDataflowInvalidLastTransformation: 'WranglingDataflowValidationFailed: last transformation {0}',
    Operation_WranglingDataflowInvalidDataTypes: 'WranglingDataflowValidationFailed: Invalid data types with message {0}',
    Operation_WranglingDataflowConvertDataflowClicked: 'WranglingDataflowConvertDataflowClicked',

    Operation_ResourceGridAddRow: 'ResourceGridAddRow',
    Operation_ResourceGridRemoveRow: 'ResourceGridRemoveRow',

    // Gallery/Template
    Operation_SaveGalleryTemplate: 'SaveTemplate',
    Operation_EditGalleryTemplate: 'EditTemplate',
    Operation_UpdateGalleryTemplate: 'UpdateTemplate',
    Operation_DeleteGalleryTemplate: 'DeleteTemplate',
    Operation_ViewGallery: 'ViewGallery',
    Operation_CloseGallery: 'CloseGallery',
    Operation_BackToGallery: 'BackToGallery',
    Operation_ViewGalleryTemplate: 'ViewTemplate',
    Operation_UseGalleryTemplate: 'UseTemplate',
    Operation_PublishPipelineFromTemplate: 'PublishedPipelineFromTemplate', // only the main pipeline of each template will be counted when published, used to track template's publish count
    Operation_PipelineFromTemplate: 'PipelineFromTemplate', // all pipeline created from template and published will be recorded, used to track pipeline's source template
    Operation_SavePipelineFromTemplate: 'SavePipelineFromTemplate',
    Operation_DebugPipelineRunFromTemplate: 'DebugPipelineRunFromTemplate',
    Operation_ExportTemplate: 'ExportTemplate',
    Operation_DownloadedExportedTemplate: 'DownloadedExportedTemplate',
    Operation_ExportTemplateFromPipeline: 'ExportTemplateFromPipeline',
    Operation_SavePipelineAsTemplate: 'SavePipelineAsTemplate',
    Operation_ImportTemplateToUsePipeline: 'ImportTemplateToUsePipeline',
    Operation_ImportTemplateToSaveInGallery: 'ImportTemplateToSaveInGallery',
    Operation_SaveTemplateInLiveMode: 'SaveTemplateInLiveMode',
    Operation_ClickUseTemplateButton: 'Click use button',
    Operation_ClickBack2TemplatesButton: 'Click back button',
    Operation_ClickCloseTemplateButton: 'Click close detail button',
    Operation_ClickCloseTemplatesButton: 'Click close list button',

    Message_UseTemplate: 'Use pipeline template',
    Message_BackToTemplates: 'Back from pipeline template detail panel',
    Message_CloseTemplate: 'Close pipeline template detail panel',
    Message_CloseTemplates: 'Close pipeline templates list panel',

    // Metric Alerts
    Operation_NewAlertCriteria: 'AddNewTargetCriteria',

    // Operation Tracking
    OperationTracking_Publish: 'PublishTrackingKey',
    OperationTracking_PostPublish: 'PostPublishTrackingKey',
    OperationTracking_ExportArmTemplate: 'ExportArmTemplateTrackingKey',

    // Operation Self Hosted IR
    Operation_AddSelfHostedIr: 'AddSelfHostedIR',
    Operation_RemoveSelfHostedIr: 'RemoveSelfHostedIR',

    Operation_ShareSSISIR: 'ShareSSISIR',
    Operation_GetLinkedDatafactories: 'GetLinkedDatafactories',
    Operation_GetLinkedSsisIrResourceIds: 'GetLinkedSsisIrResourceIds',

    // Operations SSIS IR
    Operation_ChangeIRName: 'ChangeIRName',
    Operation_ChangeRegionValue: 'ChangeRegionValue',
    Operation_ChangeNodeSize: 'ChangeNodeSize',
    Operation_ChangeNodeNumber: 'ChangeNodeNumber',
    Operation_ChangeSkuValue: 'ChangeSkuValue',
    Operation_ChangeLicenseType: 'ChangeLicenseType',
    Operation_ChangeUseSSISDBToTrue: 'ChangeUseSSISDBToTrue',
    Operation_ChangeUseSSISDBToFalse: 'ChangeUseSSISDBToFalse',
    Operation_ChangeSubscriptionValue: 'ChangeSubsciptionValue',
    Operation_ChangeServerName: 'ChangeServerName',
    Operation_ChangeUserName: 'ChangeUserName',
    Operation_ChangePassword: 'ChangePassword',
    Operation_ChangeUseAADToTrue: 'ChangeUseAADToTrue',
    Operation_ChangeUseAADToFalse: 'ChangeUseAADToFalse',
    Operation_ChangeUseUAMIToTrue: 'ChangeUseUAMIToTrue',
    Operation_ChangeUseUAMIToFalse: 'ChangeUseUAMIToFalse',
    Operation_ChangeCredentialValue: 'ChangeCredentialValue',
    Operation_ChangeTierValue: 'ChangeTierValue',
    Operation_ChangeExecutionPerNode: 'ChangeExecutionPerNode',
    Operation_ChangeCustomSetup: 'ChangeCustomSetup',
    Operation_ChangeCustomSetupWithoutScript: 'ChangeCustomSetupWithoutScript',
    Operation_ChangeCustomSetupAllowdToTrue: 'ChangeCustomSetupAllowedToTrue',
    Operation_ChangeCustomSetupAllowdToFalse: 'ChangeCustomSetupAllowedToFalse',
    Operation_ChangeJoinVnetAllowedToTrue: 'ChangeJoinVnetAllowedToTrue',
    Operation_ChangeJoinVnetAllowedToFalse: 'ChangeJoinVnetAllowedToFalse',
    Operation_ChangeBringIpAllowedToTrue: 'ChangeBringIpAllowedToTrue',
    Operation_ChangeBringIpAllowedToFalse: 'ChangeBringIpAllowedToFalse',
    Operation_ChangeStagingLinkedServiceValueToUndefined: 'ChangeStagingLinkedServiceValueToUndefined',
    Operation_ChangeVnetType: 'ChangeVnetType',
    Operation_ChangeVnetValue: 'ChangeVnetValue',
    Operation_ChangeSubnetValue: 'ChangeSubnetValue',
    Operation_ChangeFirstIpValue: 'ChangeFirstIpValue',
    Operation_ChangeSecondIpValue: 'ChangeSecondIpValue',
    Operation_ChangeLinkSelfHostedIR: 'ChangeLinkSelfHostedIR',
    Operation_UseMIPublicEndpoint: 'UseMIPublicEndpoint',
    Operation_CreateSSISPipeline: 'CreateSSISActivityPipeline',
    Operation_UseClassicVnet: 'UseClassicVnet',

    // Private connection
    Operation_NewPrivateEndpoint: 'NewPrivateEndpoint',
    Operation_DeletePrivateEndpoint: 'DeletePrivateEndpoint',

    // Application comparison
    Operation_ChooseTargetApplication: 'ChooseTargetApplication',
    Operation_CompareSparkJob: 'CompareSparkJob',
    Operation_DetectRecurrent: 'DetectRecurrentApplication, application name is {0}',
    Operation_SelectFromURL: 'SelectFromURL',
    Operation_SelectFromRecurrentJob: 'SelectFromRecurrentJob',

    // Access Control
    // Access Control Tab: AccessControlTabComponent
    AccessControl_RetrievingAdminList: 'listAdmins - Retrieving admin list',
    AccessControl_NotAuthorized: 'listAdmins - Not authorized',
    AccessControl_RetrievedAdmins: 'listAdmins - Retrieved {0} admins',
    AccessControl_RetrievedNoAdmin: 'listAdmins - Retrieved no admin.',
    AccessControl_ClickAddButton: 'AddAdmin',
    AccessControl_SidebarOpen: 'addAdmin  - Access control Sidenav open',
    AccessControl_AddAdminDone: 'addAdmin - Add admin done',
    AccessControl_AddAdminFail: 'addAdmin - Add admin fail: {0}',
    AccessControl_RefreshUserList: 'RefreshUserList',
    AccessControl_ClickRemoveButton: 'RemoveAdmin',
    AccessControl_RemoveAdminDone: 'removeAdmin - Remove admin done',
    AccessControl_RemoveAdminFail: 'removeAdmin - Remove admin fail: {0}',
    AccessControl_FailedThreeTrys: 'addOrRemoveAdmin - Failed to run three trys.',

    AccessControl_addAdmins: 'admins to add: {0}',
    AccessControl_removeAdmins: 'admins to remove: {0}',

    // A365WorkspaceAccessControlApiService
    AccessControlApi_getUserAccessControlRequest: 'getMyRoles - send GET getMyAssignedRoles request',
    AccessControlApi_getUserAccessControlRequestResponse: 'getMyRoles - result of GET getMyAssignedRoles: {0}',
    AccessControlApi_getAccessControlRequest: 'listAdmins - send GET roleAssignments request',
    AccessControlApi_getMyAccessControlRequest: 'listAdmins - send GET roleAssignments request for login user',
    AccessControlApi_createAccessControlRequest: 'createAdmins - send POST roleAssignments request',
    AccessControlApi_deleteAccessControlRequest: 'deleteAdmins - send DELETE roleAssignments request',

    AccessControlApi_NoWorkspacePermissionWithError: 'No workspacePermission - Not authorized. Code: {0}. Message: {1}',
    AccessControlApi_NoWorkspacePermission: 'No workspacePermission - Request returns empty array',

    // UserAndGroupSelectListComponent
    AccessControlSidebar_SearchUserAndGroup: 'SearchUserAndGroup - first search',
    AccessControlSidebar_SearchUserAndGroupNextLink: 'SearchUserAndGroup - nextLink search',
    AccessControlSidebar_SearchError: 'SearchUserAndGroup - searchError: {0}',
    AccessControlSidebar_noSearchResult: 'SearchUserAndGroup - noSearchResult',
    AccessControlSidebar_ClickApplyAddNewUserOrGroup: 'Apply',
    AccessControlSidebar_ClickCancelAddNewUserOrGroup: 'Cancel',

    // Show watermark
    AccessControl_displayWatermark: 'Display watermark',

    // Bulkload
    Bulkload_Component_Created: 'Component created',
    BulkLoad_Continue: 'Continue',
    BulkLoad_OpenScript: 'Open script',
    BulkLoad_OpenScript_WithExecuteCheckBox: 'Open script with execute checkbox',
    BulkLoad_ConfigureColumnMapping: 'Configure column mapping',

    // feature-level feedback
    Feedback_InitialSubmit: 'Submit initial feedback',
    Feedback_InitialClose: 'Close initial feedback',
    Feedback_InitialShow: 'Show initial feedback',
    Feedback_AdditionalYes: 'Opt-in for additional feedback',
    Feedback_AdditionalNo: 'Not participating in additional feedback',
    Feedback_AdditionalCancel: 'Cancel additional feedback',
    Feedback_AdditionalSubmit: 'Submit additional feedback',
    Feedback_NpsNo: 'Close NPS survey',

    // focus mode
    FocusMode_EnterFocusMode: 'Enables focus mode',
    FocusMode_QuitFocusMode: 'Quits focus mode',

    // babylon
    Babylon_ConnectButton: 'Connect to Babylon button',
    Babylon_EditButton: 'Edit Babylon button',
    Babylon_DisconnectButton: 'Disconnect from Babylon button',
    Babylon_AboutTab: 'About Babylon Tab',
    Babylon_AccountTab: 'Babylon account Tab',
    Babylon_CancelConnect: 'Cancel Babylon connection button',
    Babylon_ApplyConnect: 'Apply Babylon connection button',

    // Fabric
    Fabric_ConnectButton: 'Connect to Fabric workspaces button',
    Fabric_MountButton: 'Mount Fabric workspaces button',
    Fabric_DisconnectButton: 'Disconnect from Fabric workspaces button',
    Fabric_CancelConnect: 'Cancel Fabric connection button',
    Fabric_UnlicensedDetected: 'Fabric unlicensed user detected in mount panel',
    Fabric_SignUpInitiated: 'Fabric sign-up initiated from mount panel',
    Fabric_SignUpRetry: 'Retry workspace listing after Fabric sign-up',
    Fabric_TrialProvisioningStarted: 'Fabric trial capacity provisioning started',
    Fabric_TrialProvisioningSucceeded: 'Fabric trial capacity provisioning succeeded',
    Fabric_TrialProvisioningFailed: 'Fabric trial capacity provisioning failed',
    Fabric_TrialRedirectToFabric: 'Trial failed, redirecting user to Fabric portal for mount',
    Fabric_AutoProvisionStage: 'Fabric auto-provisioning stage',
    Fabric_AutoProvisionButton: 'View in Fabric (Preview) auto-provision button',
    Fabric_MyWorkspaceMountStep: 'Fabric My Workspace mount step',
    Fabric_CapacitySelectionProvisioning: 'Fabric capacity-selection provisioning',
    Fabric_WorkspaceAccessDecision: 'Fabric workspace access decision',
    Fabric_WorkspaceReaderSync: 'Fabric workspace reader sync',
    Fabric_WorkspaceReplacement: 'Fabric View in Fabric workspace replacement',

    // Git operation
    Operation_Commit: 'Commit',

    // Mapping artifact actions
    Operation_MappingArtifactGeneratePipelines: 'GeneratePipelinesFromMappingArtifact',

    // Mapping artifact actions
    Operation_StartAdfDataMapper: 'StartAdfDataMapper',
    Operation_StopAdfDataMapper: 'StopAdfDataMapper',

    // Pipeline runs - activity run
    Operation_OpenSparkApplicationMonitor: 'Open spark application monitor',

    // workspace setting
    Operation_ChangeAutosaveState: 'Change autosave state',

    // User Defined Functions
    Operation_ParseUdfDslAsync: 'Parse UDF DSL',
    Operation_NewUDFButton: 'New UDF Library Button clicked',
    Operation_EditUDFButton: 'Edit UDF Library Button clicked',
    Operation_DeleteUDF: 'Delete UDF Library',
    Operation_UDFTabOpened: 'Open UDF Library List',
    Operation_UDFUsedInExpressionBuilder: 'UDF selected in expression builder',
    Operation_ImportUDF_Code: 'Import UDF Library from Code',
    Operation_ImportUDF_File: 'Import UDF Library from file',
    Operation_ExportUDF: 'Export UDF Library',
    Operation_ShowUDFJson: 'Show UDF Library JSON',

    // Data first view
    Operation_SwitchDataFirstViewOn: 'SwitchDataFirstViewOn',
    Operation_SwitchDataFirstViewOff: 'SwitchDataFirstViewOff',
    Operation_ToggleDataFirstCanvas: 'ToggleDataFirstCanvas',

    // Create Data Factory
    Operation_VisitEntryNoSubs: 'VisitEntryNoSubs',
    Operation_VisitEntryNoFactories: 'VisitEntryNoFactories',
    Operation_VisitCreateFactoryHasFactories: 'VisitEntryHasFactories',
    Operation_FreeTrialClicked: 'FreeTrialClicked',
    Operation_AzurePortalLinkClicked: 'AzurePortalLinkClicked',
    Operation_EntryRefreshSubsSuccess: 'EntryRefreshSubsSuccess',
    Operation_EntryRefreshSubsFail: 'EntryRefreshSubsFail',
    Operation_CreateFirstDataFactory: 'CreateFirstDataFactory',
    Operation_CreateNewDataFactory: 'CreateNewDataFactory',
    Operation_CreateNewDataFactoryFromSwitchClicked: 'CreateNewDataFactoryFromSwitchClicked',
    Operation_CreateNewDataFactoryLocationChanged: 'CreateNewDataFactoryLocationChanged',
    Operation_CreateNewDataFactorySubscriptionChanged: 'CreateNewDataFactorySubscriptionChanged',

    // Learning Module
    Operation_VisitLearningCenter: 'VisitLearningCenter',
    Operation_CalloutShown: 'CalloutShown',

    //performance
    Operation_ChunkLoaded: 'Chunk Loaded', // PBI report reference this word, pls not change value

    //Docs Search + new search
    Operation_DocSearchResultClicked: 'DocSearchResultClicked',
    Operation_DocSeeMoreClicked: 'DocSearchSeeMoreClicked',
    Operation_GlobalSearchRecentResourceClicked: 'GlobalSearchRecentResourceClicked',
    Operation_GlobalSearchHistoryResultClicked: 'GlobalSearchHistoryResultUsed',
    Operation_PipelineMonitoringAutocompleteClicked: 'PipelineMonitoringAutocompleteClicked',

    // Unified connection in Trident
    Operation_LoadMashupEditor: 'Operation_LoadMashupEditor',
    Operation_MashupEditorReady: 'Operation_MashupEditorReady',
    Operation_StartCreateConnectionFlow: 'Operation_StartCreateConnectionFlow',
    Operation_StartConnectToDataSourceFlow: 'Operation_StartConnectToDataSourceFlow',
    Operation_StartEditConnectionFlow: 'Operation_StartEditConnectionFlow',

    // Sample dataset
    Operation_BrowseSampleDataset: 'BrowseSampleDataset',
    Operation_SelectSampleDataset: 'SelectSampleDataset',

    // Copy job
    Operation_CopyJobRun: 'Operation_CopyJobRun',
    Operation_CopyJobReset: 'Operation_CopyJobReset',
    Operation_CopyJobUpdate: 'Operation_CopyJobUpdate',
    Operation_CopyJobEnableTimestampNtz: 'Operation_CopyJobEnableTimestampNtz',

    ...copilotActions,

    // Pipeline settings
    Operation_PipelineConcurrencyUpdate: 'Operation_PipelineConcurrencyUpdate',

    // Expression Copilot Events
    ExpressionBuilder_Open: 'ExpressionBuilder_Open',
    ExpressionBuilder_Close: 'ExpressionBuilder_Close',
    CloseType_Confirm: 'Confirm',
    CloseType_Cancel: 'Cancel',
    ExpressionBuilder_ExpressionError: 'ExpressionBuilder_ExpressionError',
    ExpressionBuilder_ExpressionEvaluate: 'ExpressionBuilder_ExpressionEvaluate',

    // Migration events
    Operation_OpenMigrationTool: 'OpenMigrationTool',
    Migration_AnalysisResults: 'MigrationAnalysis',
    Migration_Operation_AnalysisCompleted: 'AnalysisCompleted',
    Migration_Operation_AssessmentExported: 'AssessmentExported',
    Migration_Operation_Started: 'MigrationStarted',
    Migration_Operation_Completed: 'MigrationCompleted',
    Migration_Operation_ResultsExported: 'ResultsExported'
};

export const queryAPIOperations: string[] = [
    loggerConstants.Operation_TestConnection,
    loggerConstants.Operation_QueryAPINavigation,
    loggerConstants.Operation_ImportSchema,
    loggerConstants.Operation_PreviewData,
    loggerConstants.Operation_DetectFileFormat,
    loggerConstants.Operation_ListStoredProcedure,
    loggerConstants.Operation_ListStoredProcedureParameter,
    loggerConstants.Operation_ListFunction,
    loggerConstants.Operation_ListFunctionParameter,
    loggerConstants.Operation_DynamicsAlternateKey,
    loggerConstants.Operation_PreviewScript,
    loggerConstants.Operation_GetItemMetadata,
    loggerConstants.Operation_ReadStream,
    loggerConstants.Operation_WriteStream,
    loggerConstants.Operation_DetectColumnMapping,
    loggerConstants.Operation_ExecuteTabularData,
    loggerConstants.Operation_ResolveExpressions,
    loggerConstants.Operation_ValidateCopyRuntime
];
